import React, { ReactNode } from "react";

import Footer from "./Footer";

type Props = {
  children: ReactNode;
};

const FooterLayout: React.FC<Props> = (props) => {
  const { children } = props;
  return (
    <div id="wrap">
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default FooterLayout;
